import React from 'react';

import { withJobs } from '../../hocs/withJobs';
// TODO: Look into lazy loading these.
import JobsCarousel from './JobsCarousel';

const JobsWidget = (props) => <JobsCarousel {...props} />;

export default withJobs(JobsWidget);
